import React from 'react';


function M3(props){
    const columns = [];

    props.data.contentText.forEach((list)=>{
        let items = [];

        list.items.forEach((item)=>{
            items.push(
                <li className="c3_item" key={item.id}>{item.title}</li>
            );
        });

        columns.push(
            <ul className="m3_column c3" key={list.id}>
                {items}
            </ul>
        );
    });

    return <section className="m3">
        <div className="container">
            <header className="m3_header c1">
                <h1 className="c1_headline">{props.data.title}</h1>
                <h2 className="c1_subheadline">{props.data.subtitle}</h2>
            </header>
            <div className="m3_columns">
                {columns}
            </div>
            <footer className="m3_footer">{props.data.footerText}</footer>
        </div>
    </section>
}

export default M3;
